import script from "./SignInAllSetPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInAllSetPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInAllSetPage.vue?vue&type=style&index=0&id=263ede10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263ede10"]])

export default __exports__